import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ApplicationType } from '@shared/core';

@Component({
    selector: 'mca-logo-picker',
    templateUrl: './logo-picker.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoPickerComponent {
    public ApplicationType = ApplicationType;
    @Input() appType: ApplicationType | null | undefined;
    @Input() scale: number = 1.0;
}
